import { ChangeDetectionStrategy, Component, input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Color, LegendPosition, ScaleType } from '@glitchtip/ng-charts';

@Component({
  selector: 'app-treatment-chart',
  templateUrl: './treatment-chart.component.html',
  styleUrls: ['./treatment-chart.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TreatmentChartComponent implements OnChanges {
  faChevronRight = faChevronRight;

  summaryInfoRegion = input.required<any>();
  summaryInfoForest = input.required<any>();
  summaryInfoSelected = input.required<any>();

  treatmentData: any;
  colorScheme: string | Color = {
    domain: ['#45AB9F', '#8E704F', '#FFD579', '#FF9110', '#B1BD29', '#79AB45', '#4C7600'],
    name: '',
    selectable: false,
    group: ScaleType.Ordinal
  };
  legendPosition: LegendPosition = LegendPosition.Below;
  yLabel = 'Region';

  summaryData = new MatTableDataSource<any>();
  totalAuth = 0;
  totalReq = 0;
  totalFires = 0;
  totalAcres = 0;
  displayedColumns = [
    'authorized_funding',
    'requested_funding',
    'fires',
    'nfs_acres'
  ];
  displayedColumns_forest = [
    'treatment',
    'authorized_funding',
    'requested_funding',
  ];
  constructor() {

  }

  ngOnChanges(): void {
    this.displayedColumns = this.displayedColumns.filter((item: string) => (item != 'region') && (item != 'forest'));

    if (this.summaryInfoRegion()) {//region level
      this.yLabel = 'Region';
      this.displayedColumns.unshift('region');
      this.summaryData.data = this.summaryInfoRegion();
      this.calcTotals();
      this.treatmentData = this.summaryInfoRegion().map((record: any) => {
        return {
          "name": record.region,
          "series":
            [
              { "name": "Channel", "value": record.channel },
              { "name": "Roads", "value": record.roads },
              { "name": "Heritage", "value": record.heritage },
              { "name": "trails", "value": record.trails },
              { "name": "Ground Cover", "value": record.ground_cover },
              { "name": "Plants", "value": record.plants },
              { "name": "Monitoring", "value": record.monitoring }
            ]
        }
      });
    }
    else if (this.summaryInfoForest()) { //forest level info
      this.yLabel = 'Forest Name'
      this.displayedColumns.unshift('forest');
      this.summaryData.data = this.summaryInfoForest();
      this.calcTotals();
      this.treatmentData = this.summaryInfoForest().map((record: any) => {
        return {
          "name": record.forest_name,
          "series":
            [
              { "name": "Channel", "value": record.channel },
              { "name": "Roads", "value": record.roads },
              { "name": "Heritage", "value": record.heritage },
              { "name": "Trails", "value": record.trails },
              { "name": "Ground Cover", "value": record.ground_cover },
              { "name": "Plants", "value": record.plants },
              { "name": "Monitoring", "value": record.monitoring }
            ]
        }
      })
    }
    else { //single forest
      this.yLabel = 'Treatment Type';
      let tableData =
        [
          { "treatment": "Channel", "authorized": this.summaryInfoSelected().channel, "requested": this.summaryInfoSelected().channel_req },
          { "treatment": "Roads", "authorized": this.summaryInfoSelected().roads, "requested": this.summaryInfoSelected().roads_req },
          { "treatment": "Heritage", "authorized": this.summaryInfoSelected().heritage, "requested": this.summaryInfoSelected().heritage_req },
          { "treatment": "Trails", "authorized": this.summaryInfoSelected().trails, "requested": this.summaryInfoSelected().trails_req },
          { "treatment": "Ground Cover", "authorized": this.summaryInfoSelected().ground_cover, "requested": this.summaryInfoSelected().ground_cover_req },
          { "treatment": "Plants", "authorized": this.summaryInfoSelected().plants, "requested": this.summaryInfoSelected().plants_req },
          { "treatment": "Monitoring", "authorized": this.summaryInfoSelected().monitoring, "requested": this.summaryInfoSelected().monitoring_req }
        ];
      tableData = tableData.sort((a: any, b: any) => a.authorized < b.authorized ? 1 : -1);
      this.summaryData.data = tableData;
      this.calcTotals();
      this.treatmentData =
        [
          { "name": "Channel", "value": this.summaryInfoSelected().channel },
          { "name": "Roads", "value": this.summaryInfoSelected().roads },
          { "name": "Heritage", "value": this.summaryInfoSelected().heritage },
          { "name": "Trails", "value": this.summaryInfoSelected().trails },
          { "name": "Ground Cover", "value": this.summaryInfoSelected().ground_cover },
          { "name": "Plants", "value": this.summaryInfoSelected().plants },
          { "name": "Monitoring", "value": this.summaryInfoSelected().monitoring }
        ]
      this.treatmentData = this.treatmentData.sort((a: any, b: any) => a.value < b.value ? 1 : -1);
    }
  }

  calcTotals() {
    this.totalAuth = 0;
    this.totalReq = 0;
    this.totalFires = 0;
    this.totalAcres = 0;

    this.summaryData.data.forEach((record: any) => {
      this.totalAuth += record.total_auth ?? 0;
      this.totalReq += record.total_req ?? 0;
      this.totalFires += record.fire_count ?? 0;
      this.totalAcres += record.nfs_acres ?? 0;
    })
  }

  formatDollar(val: any) {
    return '$' + val;
  }
}